import UploadAPI from "../serviceAPI/UploadAPI";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  progress: 0,
  photoId: 0,
  previewImage: null,
  selectedFile: null,
  setSelectedFiles: [],
  multipleProgress: 0,
  multipleFileDetails: [],
  mutliplePhotoIds: [],
  filteredIdForDelete: "",
  errorCode: null,
};

export const fileUpload = createAsyncThunk(
  "fileUpload",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const res = await UploadAPI.UploadNewFile({ file: data }, dispatch);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const fileUploadWithParams = createAsyncThunk(
  "fileUploadWithParams",
  async ({ file, id, type }, { dispatch, rejectWithValue }) => {
    try {
      const res = await UploadAPI.UploadNewFile({ file, id, type }, dispatch);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const fileDelete = createAsyncThunk(
  "fileDelete",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      if (id.id === "" || id.id === null) {
        return;
      }
      const res = await UploadAPI.DeleteUploadedFile(id, dispatch);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const multipleFileUpload = createAsyncThunk(
  "multiFileUpload",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const res = await UploadAPI.UploadMultipleFiles(data, dispatch);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

const FileUploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {
    addFile: (state, action) => {
      let newData = {};
      if (action.payload.type === "thumbnail") {
        const id = action.payload.id;
        newData = {
          id,
          data: {
            thumbnail: action.payload.file,
            thumbnailProgress: 0,
            thumbnailPreviewUrl: URL.createObjectURL(action.payload.file),
          },
        };
        const file = state.setSelectedFiles.find((file) => file.id === id);
        if (file) {
          file.data = {
            ...file.data,
            thumbnail: action.payload.file,
            thumbnailProgress: 0,
            thumbnailPreviewUrl: URL.createObjectURL(action.payload.file),
          };
        } else {
          state.setSelectedFiles.push(newData);
        }
      } else {
        const id = action.payload.id;
        newData = {
          id,
          data: {
            file: action.payload.file,
            progress: 0,
            previewUrl: URL.createObjectURL(action.payload.file),
          },
        };
        const file = state.setSelectedFiles.find((file) => file.id === id);
        if (file) {
          file.data = {
            ...file.data,
            file: action.payload.file,
            progress: 0,
            previewUrl: URL.createObjectURL(action.payload.file),
          };
        } else {
          state.setSelectedFiles.push(newData);
        }
      }
    },
    uploadEachProgress: (state, action) => {
      const { id, progress, type } = action.payload;
      const file = state.setSelectedFiles.find((file) => file.id === id);
      if (file) {
        if (type === "thumbnail") {
          file.data.thumbnailProgress = progress;
        } else if (type === "file") {
          file.data.progress = progress;
        }
      }
    },
    removeEachFile: (state, action) => {
      const { id, type } = action.payload;
      const file = state.setSelectedFiles.find((file) => file.id === id);
      if (file) {
        if (type === "thumbnail") {
          file.data.thumbnailProgress = 0;
          file.data.thumbnail = null;
          file.data.thumbnailPreviewUrl = null;
        } else if (type === "file") {
          file.data.progress = 0;
          file.data.file = null;
          file.data.previewUrl = null;
        }
      }
    },
    cancelResUpload: (state, action) => {
      state.setSelectedFiles = [];
    },
    progressPercentage: (state, action) => {
      state.progress = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    previewImage: (state, action) => {
      state.previewImage = action.payload;
    },
    mutlipleProgressPercentage: (state, action) => {
      state.multipleProgress = action.payload;
    },
    setMultipleFileDetails: (state, action) => {
      state.multipleFileDetails = action.payload;
    },
    setFilteredIdForDelete: (state, action) => {
      state.filteredIdForDelete = action.payload;
    },
    resetMultipleFileUpload: (state) => {
      state.multipleProgress = 0;
      state.multipleFileDetails = [];
      state.mutliplePhotoIds = [];
      state.filteredIdForDelete = "";
    },
    resetMediaErrorAlert: (state, action) => {
      state.errorCode = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fileUpload.fulfilled, (state, action) => {
        state.photoId = action.payload?.[0]._id;
      })
      .addCase(fileUpload.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(fileUploadWithParams.fulfilled, (state, action) => {
        state.photoId = action.payload?.[0]._id;
      })
      .addCase(fileUploadWithParams.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(multipleFileUpload.fulfilled, (state, action) => {
        state.mutliplePhotoIds = action.payload.map((payload) => ({
          fileId: payload._id,
          fileName: payload.fileName,
        }));
      })
      .addCase(multipleFileUpload.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(fileDelete.fulfilled, (state) => {
        if (state.filteredIdForDelete !== '') {
          const index = state.mutliplePhotoIds
            .map((item) => item.fileId)
            .indexOf(state.filteredIdForDelete);
          state.mutliplePhotoIds.splice(index, 1);
          state.filteredIdForDelete = '';
        }
      })
      .addCase(fileDelete.rejected, (state, action) => {
        state.errorCode = action.payload;
      });
  },
});

export const {
  resetUploadFile,
  progressPercentage,
  setSelectedFile,
  previewImage,
  mutlipleProgressPercentage,
  setMultipleFileDetails,
  setFilteredIdForDelete,
  resetMultipleFileUpload,
  resetMediaErrorAlert,
  uploadEachProgress,
  addFile,
  removeEachFile,
  cancelResUpload,
} = FileUploadSlice.actions;
export default FileUploadSlice.reducer;
